<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_WRD_NM')" :vertical="false" />
          </div>
          <div class="col-xs-4">
            <div class="comm_label">{{this.wordName}}</div>
          </div>
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_WRD_PHSC_NM')" :vertical="false" />
          </div>
          <div class="col-xs-4">
            <div class="comm_label">{{this.wordPhysicalName}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_WRD_EN_NM')" :vertical="false" />
          </div>
          <div class="col-xs-10">
            <div class="comm_label">{{this.wordNameEn}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_WRD_TYP_NM')" :vertical="false" />
          </div>
          <div class="col-xs-4">
            <div class="comm_label">{{this.wordTypeName}}</div>
          </div>
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_DOM_CTGR_CON')" :vertical="false" />
          </div>
          <div class="col-xs-4">
            <div class="comm_label">{{this.domainClassificationName}}</div>
            <div class="comm_label">{{this.domainName}}</div>

          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_CHIN')" :vertical="false" />
          </div>
          <div class="col-xs-10">
            <div class="comm_label">{{this.chineseCharacterWord}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_WRD_SRC')" :vertical="false" />
          </div>
          <div class="col-xs-10">
            <textarea :disabled="true" v-model="originWord"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_WRD_DSCR')"  :required="true" :vertical="false" />
          </div>
          <div class="col-xs-10">
            <textarea :disabled="true" v-model="wordsContent"></textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label :label="$t('MSG_TXT_APPL_CNTN')" :required="true" :vertical="false" />
          </div>
          <div class="col-xs-10">
            <textarea v-model="leavingWordsApp"></textarea>
          </div>
        </div>
      </div>
      <div class="mrT10"></div>
      <h4><sui-input-label :label="$t('MSG_TIT_SYNO_LIST')" :vertical="false" /></h4>
      <div class="mrT10"></div>
      <sui-grid ref="gridListRelatedTerms"
        :dataset="'dataset0'"
        :columns="gridColumns0"
        :enabletooltips="false"
        :columnsresize="true"
        :columnsautoresize="false"
        :autowidth="true"
        :initialPagesize="5"
        :showDisplayCountControl="false"
        width="100%"
        >
      </sui-grid>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button type="button" class="comm_btn_border" @click="onPopupCancelClicked">{{$t('MSG_BTN_CANCEL')}}</sui-button>
      <sui-button type="button" class="comm_btn_solid" @click="submitRequest" v-permission:create="'PGE_CMT_00002'">{{$t('MSG_BTN_APPL')}}</sui-button>
    </div>
  </div>
</template>
<script>
 export default {
    name: 'PGE_CMT_00002_P02',
    props: {
      parentPageId:{
        type: String,
        default: '',
      },
      biddingInformationParam: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
       return {
        wordName : '',
        wordTypeName:'',
        wordPhysicalName : '',
        wordNameEn : '',
        domainClassificationId : '',
        domainName: '',
        domainId:'',
        applicationUserId: this.$store.getters.userInfo.knoxId,
        chineseCharacterWord: '',
        originWord: '',
        wordsContent: '',
        domainClassificationName: '',
        leavingWordsApp: '',
        wordTermData:[],
        selectData: {
          COD_WRD_TYPE_DIV: { label: '', key: '' }
        },
        gridColumns0: [
          {
            text: this.$t('MSG_TXT_WRD_NM'),
            datafield: 'similarityWordName',
          },
          {
            text: this.$t('MSG_TXT_WRD_DSCR'),
            datafield: 'similarityWordContent',
          }
        ],
      };
    },
    datasets: [
      {
        id: "dataset0",
        type: "local",
        data: "localdata0",
        datafields: [
          {
            name: "similarityWordName",
            type: "string",
            map: "similarityWordName"
          },
          {
            name: "similarityWordContent",
            type: "string",
            map: "similarityWordContent"
          }
        ]
      }
    ],
    computed: {},
    watch: {},
    mounted() {
      this.setData();
      this.getTermRelation(this.biddingInformationParam.wordId);
    },
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {
      setData(){
        this.selectData.COD_WRD_TYPE_DIV = {
          key : this.biddingInformationParam.wordTypeCode,
          label : this.biddingInformationParam.wordTypeName
        }
        // this.selectData.COD_WRD_TYPE_DIV.key  = this.biddingInformationParam.wordTypeCode;
        this.domainName = this.biddingInformationParam.domainName;
        this.domainId = this.biddingInformationParam.domainId;
        this.wordName = this.biddingInformationParam.wordName;
        this.wordPhysicalName = this.biddingInformationParam.wordId;
        this.wordNameEn = this.biddingInformationParam.wordEnglishName;
        this.domainClassificationId = this.biddingInformationParam.domainClassificationID;
        this.domainClassificationName = this.biddingInformationParam.domainClassificationName;
        this.applicationUserId= this.$store.getters.userInfo.knoxId;
        this.chineseCharacterWord= this.biddingInformationParam.wordChineseCharacters;
        this.originWord= this.biddingInformationParam.wordSource;
        //this.wordsContent= this.biddingInformationParam.wordDescription;
        this.wordsContent= this.biddingInformationParam.wordContent;        
        this.wordTypeName = this.biddingInformationParam.wordTypeName;
        this.synonymList(this.biddingInformationParam.wordName);
      },
      // display similar word list 
      synonymList(word) {
        let queryParams = { 'word-name': word};
        http.request('PGE_CMT_00002', 'DTS_CMT_00089', {
          query: queryParams
          })
          .then(res => {
            this.dataset0.data=res.data;
          })
          .catch(error => {
            console.log("error occured during search click");
          });
      },
      showRetrieveCall: function(event){
        console.log('Call popup')
      },
      submitRequest: function(event){
        if(this.wordTermData.length > 0)
        {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_RLT_TRM_EXISTS'), null));
        }
        //utils.isEmpty
        else if(this.leavingWordsApp.trim()){
          //utils.confirm(this.$t('MSG_ALT_IS_DEL_DATA'), this.$t('MSG_TXT_YES'), this.$t('MSG_TXT_NO'), this.submitRequestApi, () => {});
          utils.messageBox('confirm', this.$t('MSG_ALT_WANT_APPY'), null, this.confirmRouter);
        } 
        else{
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_APPL_CNTN'), null));
          return false;
        }
      },
      confirmRouter(){
        if(utils.isEqual(utils.getConfigurationValue('CFG_CMT_KNOX_APRV_YN'),'Y')){
          this.personInChargeList();
        }else {
          this.submitRequestApi();
        }
      },
      submitRequestApi: function(approvalData){
          const queryParams = {
            "domainClassificationID": this.domainClassificationId,
             "domainClassificationName" : this.domainClassificationName,
            "domainName": this.domainName,
            "domainId" : this.domainId,
            "wordChineseCharacters": this.chineseCharacterWord,
            "wordApplicationContent": this.leavingWordsApp,
            "wordEnglishName": this.wordNameEn,
            "wordId": this.wordPhysicalName,
            "wordName": this.wordName,
            "wordSource": this.wordSource,
            "wordTypeCode":  this.selectData.COD_WRD_TYPE_DIV.key ,
            "wordContent" : this.wordsContent,
            "approvalData": null,
        };

        // 결재 상신 정보가 있으면 결재상신 정보 병합.
        if (!utils.isEmpty(approvalData)) {
          utils.assign(queryParams, { approvalData: approvalData });
        }

          http.request('PGE_CMT_00002', 'DTS_CMT_00014', {
            path: {
              'word-id':this.wordPhysicalName
            },
            data: queryParams,
          }).then(res => {
            if(res.data.resultCode ==  '1'){
              this.conFirm('success', this.$t('MSG_ALT_PRGS_OK'), null);
            }else{
              this.conFirm('warning', this.$t('MSG_ALT_IS_EXISTS_APPL') , null);
            }
           this.onPopupCancelClicked()
          }).catch((error) => {
            console.log(error);
          });
      },
      conFirm(type, value, subValue) {
        utils.messageBox(type, value, subValue, this.onClose);
      },
      onPopupCancelClicked() {
        this.$emit('exit',true);
      },
      getTermRelation(id) {
      if (id === null) {
        //this.datasetInfo.setRawData([]);
      } else {
        http
          .request("PGE_CMT_00002", "DTS_CMT_00077", {
            path: {
              "word-id": id
            }
          })
          .then(res => {
            this.wordTermData=res.data;
          })
          .catch(error => {
            console.log("On Row Select Error");
          });
      }
    },
    /**
     * 결재 담당자 조회 및 생성
     */ 
    personInChargeList() {
      http.request(this.parentPageId, 'DTS_CMZ_00136', {
        path: {
          'pic-type-id': 'PIC_CMT_DATA_STD_APRV',
        },
        query: {
        },
      }).then(res => {
        const personInChargeList = [];
        utils.forEach(res.data, obj => {
          const userInfo = {
            userId: obj.userId,
            aprvCode: obj.rightApprovalCode,
          };
          personInChargeList.push(userInfo);
        });
        this.onAprvClick(personInChargeList);
      });
    },
    /*
     * 결재 상신 팝업
     */
    onAprvClick(personInChargeList) {
      const objTemplate = {
        // templateId: 'TMP_CMT_APRV_DOC_DOM',
        templateId: 'TMP_CMT_APRV_DOC_WRD',
        siteId: this.$store.getters.userInfo.siteId,
        langId: this.$store.getters.userInfo.langId,
        datatStdDivNm: this.$t('MSG_TXT_WRD'),
        datatStdApplDivNm: this.$t('MSG_TXT_DEL'),
        applUserNm: this.$store.getters.userInfo.userName,
        dataStdApplCntn: utils.isEmpty(this.leavingWordsApp) ? '' : this.leavingWordsApp,
        dataStdNm: utils.isEmpty(this.wordName) ? '' : this.wordName,
        dataStdId: utils.isEmpty(this.wordPhysicalName) ? '' : this.wordPhysicalName,
        dataStdEnNm: utils.isEmpty(this.wordNameEn) ? '' : this.wordNameEn,
        wrdTypeDivNm: utils.isEmpty(this.selectData.COD_WRD_TYPE_DIV.label) ? '' : this.selectData.COD_WRD_TYPE_DIV.label,
        domClsfNm: utils.isEmpty(this.domainClassificationName) ? '' : this.domainClassificationName,
        domNm: utils.isEmpty(this.domainName) ? '' : this.domainName,
        stdWrdChinCntn: utils.isEmpty(this.chineseCharacterWord) ? '' : this.chineseCharacterWord,
        stdSrcCntn: utils.isEmpty(this.originWord) ? '' : this.originWord,
        dataStdCntn: utils.isEmpty(this.wordsContent) ? '' : this.wordsContent,
        tcdmDqIfList: [],
      };

      utils.openLayerPopup('PGE_CMZ_00012', this.aprvPopupCallback, {
        pageInitialData: {
          // 필수: 업무코드, 업무결재Id
          taskId: 'TSK_CM006003',
          taskApprovalId: 'uid',

          // 결재 제목
          title: `${this.$t('MSG_TXT_CMT_APRV_PRFX')} ${this.$t('MSG_TXT_WRD')} ${this.$t('MSG_TXT_DEL')} (${this.$t('MSG_TXT_STD_LGC_NM')} : ${this.wordName})`,
          titleReadonly: true,

          // 결재 Route
          // 선택:담당자그룹Id로 결재자 조회시 사용
          // picGroupId: 'PIC_CMS_DATA_EXTC',
          aprvUsers: personInChargeList,
          popupRoutesModify: false,
          knoxRoutesModify: false,

          // 선택: 첨부파일 DocId
          // attachDocumentId: [],
          //* 결제에 첨부파일을 등록할경우 모듈 코드 값이 필수
          // moduleCode: 'CM',

          attachModify: false,
          // 결재본문
          objTemplate,
          contentsModify: false,

        },
        size: 'xlg',
      });
    },
    
    /*
     * 결재 상신 팝업 callback
     */
    aprvPopupCallback(objAprv) {
      if (utils.isEmpty(objAprv) === false) {
        this.submitRequestApi(objAprv);
      }
    },    
    },
  };
</script>
<style scoped>
</style>
